import { Divider } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { HISTORY_TYPE, IHistoryStep, ILandingFloat, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import SingleFloatLayer from "./SingleFloatLayer"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { __ } from "src/libs/utilities"

interface IFloatsLayer {
    floats: ILandingFloat[]
    sectionId: ID 
}
const FloatsLayer = (props:IFloatsLayer) : JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>( true )
    const [floats, setFloats] = useState<ILandingFloat[]>( props.floats )
    useEffect(() => {
        setFloats( props.floats )
    }, [ props.floats ])
    
        // a little function to help us with reordering the result
        const reorder = (list: any[], startIndex: number, endIndex: number) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed); 
            return result;
        }; 
    
        const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({ 
            userSelect: "none",
            padding: 0, 
            margin: `0 0 0 0`, 
            width: "100%",
            // change background colour if dragging
            background: isDragging ? "#45526d" : "transparent", 
            // styles we need to apply on draggables
            ...draggableStyle
        });
    
        const getListStyle = (isDraggingOver: boolean) => ({
            background: isDraggingOver ? "#213146cc" : "transparent",
            padding: 0, 
            //display:"flex",
            //flexDirection:"column"
        })
        const onDragEnd = (result: any) => {
            // dropped outside the list
            if (!result.destination) {
                return;
            } 
            const _items: any[]= reorder(
                floats,
                result.source.index,
                result.destination.index
            ); 
            setFloats(_items) 
            /*
            const step: IHistoryStep = {
                data : _items.map(item => item.id),
                prevData: currentLanding.sections.map((section: ILandingSection) => section.id),
                type: HISTORY_TYPE.SECTION
            }
            updateHistory(step, { ...currentLanding, sections: _items })
            */  
        }

    return !!floats?.length 
        ?
        <>
            {/* <div className="w-50">
                <Divider color="white"/>
            </div>   */}
            {
                !!floats?.length && <div className="micro letter-spacing-5 text-center text-light p-1" >
                    <div className="text-uppercase smaller ">
                        {__( "Floats" )}
                    </div>
                </div>
            }
            <DragDropContext onDragEnd={ onDragEnd }>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={ getListStyle(snapshot.isDraggingOver) }
                        >
                            { 
                                floats?.map(( float: ILandingFloat, index: number ) => {
                                    return <div key={float.id} className="d-flex"> 
                                        <Draggable draggableId={float.id.toString()} index={index}>
                                            {(provided, snapshot) => ( 
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                > 
                                                    <SingleFloatLayer float={float}  sectionId={props.sectionId} />    
                                                </div>
                                            )}
                                        </Draggable>
                                    </div>
                                })
                            }
                        </div>
                    )}
                </Droppable >
            </DragDropContext>
            {/*     {
                isOpen && floats?.map(float => {
                    return <SingleFloatLayer float={float}  sectionId={props.sectionId}  key={float.id} />
                })
            }  */}
        </>
        :
        <></>
}

export default FloatsLayer